module.exports = __webpack_public_path__ + "static/media/waterford-logo.b5cfcf9b.png";